import { render, staticRenderFns } from "./CAFormGlobal.vue?vue&type=template&id=60672dc0&"
import script from "./CAFormGlobal.vue?vue&type=script&lang=js&"
export * from "./CAFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60672dc0')) {
      api.createRecord('60672dc0', component.options)
    } else {
      api.reload('60672dc0', component.options)
    }
    module.hot.accept("./CAFormGlobal.vue?vue&type=template&id=60672dc0&", function () {
      api.rerender('60672dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CAFormGlobal.vue"
export default component.exports